// extracted by mini-css-extract-plugin
export var clipWrapper = "scrollClipWrapper-module--clipWrapper--de1f9";
export var container = "scrollClipWrapper-module--container--48c28";